import linkifyHtml from 'linkify-html'
import { IntermediateRepresentation } from 'linkifyjs'

function convertTextToUrl (message: string) {
  const options = {
    defaultProtocol: 'https',
    attributes: {
      class: 'text-link',
    },
    rel: 'noopener noreferrer',
    target: '_blank',
    format: {
      url: (value: string) => decodeURI(value),
    },
    render: {
      url: ({ attributes, content }: IntermediateRepresentation) => {
        let attrs = ''
        for (const attr in attributes) {
          attrs += ` ${attr}="${attributes[attr]}"`
        }
        attrs += ` title="${content}"`
        return `<a${attrs}>${content}</a>`
      },
    },
    validate: (value: string, type: string) => {
      if (type !== 'url') return true

      try {
        // If URL doesn't have a protocol, prepend the default one
        const urlWithProtocol = value.match(/^https?:\/\//) ? value : `https://${value}`
        const url = new URL(urlWithProtocol)
        return !/\.(java|js|ts|cpp|py|php|go|sql|vue|tsx|jsx)$/.test(url.hostname)
      } catch {
        return false
      }
    },
  }
  return linkifyHtml(message, options)
}

function removeMailto (message: string) {
  return message.replace(/mailto:/g, '')
}
function removeTagA (message: string) {
  return message.replace(/<a.*?href="(.*?)".*?>.*?<\/a>/gi, '$1')
}
function addSpacesBeforeUrls (message: string) {
  // Add space before URLs that are directly attached to text (e.g., "text123https://example.com")
  // Match: alphanumeric character followed by http:// or https://
  return message.replace(/([a-zA-Z0-9])(https?:\/\/)/g, '$1 $2')
}

export function createLinksFromText (message: string) {
  try {
    const clearTags = removeTagA(message)
    const clearMailto = removeMailto(clearTags)
    const withSpaces = addSpacesBeforeUrls(clearMailto)
    const result = convertTextToUrl(withSpaces).trim()
    return result
  } catch {
    return message
  }
}
